module.exports = __webpack_public_path__ + "static/media/dark-mode-dashboard.15bdb002.jpg";